var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"height":"85vh"}},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"3"}},[_c('note-details')],1),_c('v-col',{attrs:{"cols":"8"}},[_c('router-view')],1),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }